export default function filters(state = { queryParams: '', options: [] }, action) {
  switch (action.type) {
    case 'SET_FILTERS':
      return { ...state, options: action.payload }
    case 'ADD_FILTER':
      return { ...state, options: [...state.options, action.payload] }
    case 'CLEAR_FILTERS':
      return { queryParams: '', options: [] }
    case 'SET_FILTERS_QUERY_PARAMS':
      return { ...state, queryParams: action.payload }
    default:
      return state
  }
}
